import apiConfig from "src/utils/apiConfig";

export const FETCH_BOOKING = "booking/fetchBookingRequest";
export const FETCH_COMPANY = "booking/fetchCompanyRequest";
export const UPDATE_COMPANY = "booking/updateCompanyRequest";
export const UPDATE_PREPAID = "booking/updatePrepaidRequest";


export const fetchBooking = (
  branchid: string | number,
  fromdate: string,
  todate: string,
  limit?: number,
  skip?: number
) => {
  const queryParams = new URLSearchParams({
    branchid: String(branchid),
    fromdate,
    todate,
  });

  if (limit !== undefined) {
    queryParams.append("limit", String(limit));
  }
  if (skip !== undefined) {
    queryParams.append("skip", String(skip));
  }

  const endpoint = `${apiConfig.GETBOOKINGREPORT}/?${queryParams.toString()}`;

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_BOOKING,
    payload: apiobject,
  };
};

export const fetchCompany = (cityid:any) => {
  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint: `${apiConfig.GETCOMPANY}/?cityid=${cityid}`,
  };

  return {
    type: FETCH_COMPANY,
    payload: apiobject,
  };
};

export const updatecompany = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.UPDATECOMPANY,
    body: payload,
  };
  return {
    type: UPDATE_COMPANY,
    payload: apiObject,
  };
};

export const updatePrepaid = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.UPDATEPREPAID,
    body: payload,
  };
  return {
    type: UPDATE_PREPAID,
    payload: apiObject,
  };
};
